import styled from 'styled-components';

export const StyledArrowButton = styled.button`
    margin: 0px;
    padding: 0px;
    background-color: #fff;
    border: none;
    border-radius: 50%;
`;
